import "./StatusIndicator.scss";

import React, { memo } from "react";

interface IProps {
  status?: string;
}

const StatusIndicator: React.FC<IProps> = memo(({ status }) => {
  return (
    <span
      data-testid="status-indicator"
      className={`status-indicator ${status}`}
    />
  );
});

export { StatusIndicator };
